export const KpiActionBarEN = {
    "kpiActionBar": {
        "tab": {
            "detail":"Detail",
        },
        "item": {
            "delete": "Delete",
            "history": "History",
            "update": "Update",
            "approval": "Approval"
        }
    }
}